module.exports = __webpack_public_path__ + "static/media/solutionspage-marketingteams-freelancer-woman-heroimage.4a44ea47.webp";